import React from 'react'
import { Center } from '../../parts/bases/Center'
import { VStack } from '../../parts/bases/VStack'
import { Text } from '../../parts/bases/Text'
import { PinkNeonButton } from '../../parts/buttons/PinkNeonButton'

export type Props = {
  email: string
  onClickButton: () => void
}

export const Layout: React.FC<Props> = (props) => {
  return (
    <VStack className="h-screen w-full">
      <Center className="w-full flex-1 items-center pb-20">
        <VStack className="w-fit gap-y-10">
          <VStack className="items-center gap-y-2">
            <Text className="text-xl font-semibold text-neon-blue">Please open the link sent to</Text>
            <Text className="text-2xl font-bold text-neon-blue">{props.email}</Text>
            <Text className="text-xl font-semibold text-neon-blue">to finish logging in.</Text>
          </VStack>
          <Center>
            <PinkNeonButton onClick={props.onClickButton}>
              <Text className="font-bold text-white">Back</Text>
            </PinkNeonButton>
          </Center>
        </VStack>
      </Center>
    </VStack>
  )
}
